import { Github } from './Github'

export const Nav = () => {
  return (
    <nav className="px-4 sm:px-8 md:px-16 lg:px-32 py-2 flex items-center justify-between w-full shadow-md bg-main-700 text-white">
      <h1 className="text-3xl font-bold">Awww yeah</h1>
      <a href="https://github.com/fuzzy-pancake" className="fill-current">
        <Github />
      </a>
    </nav>
  )
}
